import React from "react";

function NavigationBar({ backgroundBulmaColor = "black", children, id }) {
  return (
    <div id={id} className={`navbar-menu has-background-${backgroundBulmaColor}`}>
      {children}
    </div>
  );
}

export default NavigationBar;
